import React from 'react'

import FormError from "../../../gd-form/common/form-error/form-error"
import FormRowFlex from "../../../gd-form/form/form-flex/row"
import FormManager from "../../../gd-form/common/form-manager"
import FormulaEditPopoverForm from "../formula/components/form/formula-edit-popover-form"
import FormColumnFlex from "../../../gd-form/form/form-flex/column";

type Props = {
    form: FormManager
}

export default function CustomFieldFormula(props: Props) {

    return (
        <FormColumnFlex
            className   = "w-550"
            label       = "Formula"
        >
            <FormulaEditPopoverForm
                className   = "m-t-5"
                form        = {props.form}
            />
            <FormError
                className   = "formula-error"
                form        = {props.form}
                name        = "formula"
            />
        </FormColumnFlex>
    )
}